import { defineStore } from "pinia";
import EventApi from "@/api/EventApi";

export const useEventStore = defineStore("event", {
  state: () => {
    return {
      details: [],
      events: [],
      eventsToArtist: [],
      eventsToArtistInCity: [],
      eventsToArtistInCountry: [],
      eventsToArtistPast: [],
      eventsToVenues: [],
      eventsRelatedToVenue: [],
      eventsRelatedToArtist: {},
      eventsRelatedToEvent: {},
      tickets: [],
      isIframe: false,
      // Seatsio
      configSeatsio: {},
      minTickets: {},
      available: {},
      pair: {},
      media: [],
      channels: [],
      defaultChannels: []
    };
  },

  actions: {
    async getEvents(params) {
      this.events = await EventApi.getEvents(params);
    },
    async getDetails(slug) {
      if (this.isIframe) {
        this.details = await EventApi.getDetailsIframe(slug);
      } else {
        this.details = await EventApi.getDetails(slug);
      }
    },
    async getTickets(params) {
      this.tickets = [];
      await this.getTicketsPage(params, 1);
      if (this.details.fan_to_fan_available) {
        let weswapTickets = (
          await EventApi.getWeswapTickets({ event: this.details.id })
        ).transfer_tiers;
        for (const ticketsType of weswapTickets) {
          ticketsType.f2f = true;
          ticketsType.available = ticketsType.remaining;
          this.tickets.unshift(ticketsType);
        }
      }
    },
    async getTicketsPage(params, page) {
      let data = await EventApi.getTickets({ ...params, page: page });
      this.tickets = [...this.tickets, ...data.ticket_types];
      if (data.next_page) {
        await this.getTicketsPage(params, data.next_page);
      }
    },

    async getEventsRelatedToVenue(params) {
      this.eventsRelatedToVenue = (await EventApi.getEvents(params)).events;
    },
    async getEventsRelatedToArtist(params) {
      this.eventsRelatedToArtist = await EventApi.getEvents(params);
    },
    async getEventsToArtist(params) {
      this.eventsToArtist = (await EventApi.getEvents(params)).events;
    },
    async getCityArtistEvents(params) {
      this.eventsToArtistInCity = (await EventApi.getEvents(params)).events;
    },
    async getCountryEvents(params) {
      this.eventsToArtistInCountry = (await EventApi.getEvents(params)).events;
    },
    async getPreviousEvents(params) {
      this.eventsToArtistPast = (await EventApi.getEvents(params)).events;
    },
    async getEventsToVenues(params) {
      this.eventsToVenues = (await EventApi.getEvents(params)).events;
    },
    async getEventsRelatedToEvent(params) {
      this.eventsRelatedToEvent = await EventApi.getEvents(params);
    },
    async followCampaign(params) {
      await EventApi.followEvent(params);
    },
    async unfollowCampaign(params) {
      await EventApi.unfollowEvent(params);
    },
    // Seatsio
    async getSeatsioConfig(params) {
      this.configSeatsio = await EventApi.getSeatsioConfig(params);
    },
    async getSeatsioTickets(params) {
      this.tickets = (await EventApi.getTickets(params)).ticket_types;

      this.minTickets = {};
      this.available = {};
      this.pair = {};
      this.tickets.forEach(item => {
        this.minTickets[item.external_id] = item.min_tickets;
        this.available[item.external_id] = item.available;
        this.pair[item.external_id] = item.pair;
      });
    },
    async followEvent(params) {
      await EventApi.followEvent(params);
    },
    async unfollowEvent(params) {
      await EventApi.unfollowEvent(params);
    },
    async getEventMedia(params) {
      this.media = await EventApi.getEventMedia(params);
    },
    async getEventChannels(params) {
      let data = await EventApi.getEventChannels(params);
      this.channels = data.channels;
      this.defaultChannels = data.channels.filter(item => {
        return item.default;
      });
    }
  }
});
